import axios, { AxiosResponse } from 'axios';

import config from '../../../../config/config';
import { IStandardPricingQueryResponse } from '../common/models';

export const getSRStandardPricingQuery = (
  cancellationToken?: AbortSignal,
): Promise<AxiosResponse<IStandardPricingQueryResponse>> =>
  axios.get(`api/pricing/standard`, {
    baseURL: config.securityResponseApi.baseUrl,
    signal: cancellationToken,
  });

export const getSRRegularPricingQuery = (
  cancellationToken?: AbortSignal,
): Promise<AxiosResponse<IStandardPricingQueryResponse>> =>
  axios.get(`api/pricing/regular`, {
    baseURL: config.securityResponseApi.baseUrl,
    signal: cancellationToken,
  });
